import Box from '@mui/material/Box';
import { useKickSimContext } from '../Components/KickRSimContext';
import { KickSimSwitch } from '../Components/KickSimSwitch';
import { pxToRem } from 'src/common/utils/fonts';

export type RSimInventorySimulateOutageProps = {
  euicc: string;
  isPrimary: boolean;
  disabled?: boolean;
};

export const RSimInventorySimulateOutage: React.FC<RSimInventorySimulateOutageProps> = ({
  euicc,
  isPrimary,
  disabled = false,
}) => {
  const { isPrimaryProfileDisabled, isSecondaryProfileDisabled } = useKickSimContext();
  const primaryProfileDisabled = isPrimaryProfileDisabled(euicc);
  const secondaryProfileDisabled = isSecondaryProfileDisabled(euicc);

  const isDisabled =
    (isPrimary && primaryProfileDisabled) || (!isPrimary && secondaryProfileDisabled);

  return (
    <Box sx={{ minWidth: pxToRem(180), '& > label': { marginLeft: 0 } }}>
      <KickSimSwitch
        checked={isDisabled}
        profileId={isPrimary ? 0 : 1}
        euicc={euicc}
        labelPlacement="end"
        disabled={disabled}
      />
    </Box>
  );
};
